import { AuthAction } from "../auth-slice/types";
import { SubscriptionSliceState } from "./types";

export const updateUserSubscriptionReducer = (state: SubscriptionSliceState, action: AuthAction): SubscriptionSliceState => {
  const { subscription } = action.payload;
  state.current = subscription;
  return state;
};

export const removeUserSubscriptionReducer = (state: SubscriptionSliceState): SubscriptionSliceState => {
  state.current = undefined;
  return state;
}
